import { render, staticRenderFns } from "./InfoTip.vue?vue&type=template&id=d4cc9654&scoped=true&"
import script from "./InfoTip.vue?vue&type=script&lang=ts&"
export * from "./InfoTip.vue?vue&type=script&lang=ts&"
import style0 from "./InfoTip.vue?vue&type=style&index=0&id=d4cc9654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cc9654",
  null
  
)

export default component.exports